import React, { useCallback, useEffect, useState } from 'react'
import HOC from '../../components/HOC/HOC'
import addjob from '../../css/style.module.css'
import { useNavigate, useParams } from 'react-router-dom'
import img2 from '../../assest/loading1.gif'
import endPoints from '../../Repository/apiConfig'
import { deleteApi, getApi, postApi } from '../../Repository/Api'
import { formatDate } from '../../utils/utils'
import { SuccessfullyModal } from '../../components/Modals/Modals'

const UserCart = () => {
    const navigate = useNavigate()
    const { id } = useParams()
    const [show, setShow] = useState(false)
    const [loading, setLoading] = useState(false)
    const [loading1, setLoading1] = useState(false)
    const [loading2, setLoading2] = useState(false)
    const [formData, setFormData] = useState({
        jobs: [],
        outfits: [],
        equipment: [],
        mobility: [],
        contactName: '',
        phone: '',
        description: '',
        pinCode: '',
        parkingAccess: '',
        name: '',
        address: '',
        country: '',
        state: '',
        city: '',
        invoiceName: '',
        invoiceAddress: '',
        invoicePinCode: '',
        invoiceCity: '',
        invoiceCountry: '',
        companyRegistrationNumber: '',
        invoiceDetails: '',
        vat: '',
        subTotal: '',
        total: '',
    })

    const formatCartJobTime = (timestamp) => {
        let date

        if (timestamp && typeof timestamp.toMillis === 'function') {
            date = new Date(timestamp.toMillis())
        } else if (timestamp instanceof Date) {
            date = timestamp
        } else if (typeof timestamp === 'string') {
            date = new Date(timestamp)
        } else {
            return 'Invalid Time'
        }

        if (isNaN(date.getTime())) {
            return 'Invalid Time'
        }

        const hours = date.getUTCHours()
        const minutes = date.getUTCMinutes()
        const period = hours >= 12 ? 'PM' : 'AM'
        const displayHours = hours % 12 || 12

        return `${displayHours.toString().padStart(2, '0')}:${minutes
            .toString()
            .padStart(2, '0')} ${period}`
    }

    const fetchCartData = useCallback(async () => {
        await getApi(endPoints.getCartbyid(id), {
            setResponse: (response) => {
                const cart = response?.cart || {}

                // Calculate totals if not provided
                const subTotal = cart.jobs?.reduce((sum, job) => {
                    const jobTotal = job.subCategories?.reduce((jobSum, subCat) => {
                        const adults = subCat.adults || 0;
                        const kids = subCat.kids || 0;
                        const pax = subCat.pax || 0;

                        const quantity = (adults + kids) || pax || 0;
                        const total = subCat.total || (subCat.price * quantity);

                        return jobSum + total;
                    }, 0) || 0;

                    return sum + jobTotal;
                }, 0) || 0;


                const vat = cart.vat || Math.round(subTotal * 0.18) // 18% VAT
                const total = cart.total || subTotal + vat

                setFormData({
                    jobs: cart.jobs || [],
                    outfits: cart.outfits || [],
                    equipment: cart.equipment || [],
                    mobility: cart.mobility || [],
                    contactName: cart.contactName || '',
                    phone: cart.phone || '',
                    description: cart.description || '',
                    pinCode: cart.pinCode || '',
                    parkingAccess: cart.parkingAccess || '',
                    name: cart.name || '',
                    address: cart.address || '',
                    country: cart.country || '',
                    state: cart.state || '',
                    city: cart.city || '',
                    invoiceName: cart.invoiceName || '',
                    invoiceAddress: cart.invoiceAddress || '',
                    invoicePinCode: cart.invoicePinCode || '',
                    invoiceCity: cart.invoiceCity || '',
                    invoiceCountry: cart.invoiceCountry || '',
                    companyRegistrationNumber: cart.companyRegistrationNumber || '',
                    invoiceDetails: cart.invoiceDetails || '',
                    vat: vat,
                    subTotal: subTotal,
                    total: total,
                })
            },
            setLoading: setLoading,
            errorMsg: 'Failed to fetch cart data!',
        })
    }, [id])

    useEffect(() => {
        fetchCartData()
    }, [fetchCartData])

    const handleSubmit = async () => {
        const payload = {
            jobs: formData.jobs.map(job => ({
                category: job.category?._id,
                subCategories: job.subCategories.map(subCat => ({
                    subCategoryId: subCat.subCategoryId?._id,
                    fromTime: subCat.fromTime,
                    toTime: subCat.toTime,
                    adults: subCat.adults,
                    kids: subCat.kids,
                    pax: subCat.pax,
                    product: subCat.product || []
                })),
                date: job.date
            })),
            ...formData
        }

        await postApi(endPoints.addcheckout(id), payload, {
            setLoading: setLoading1,
            successMsg: 'Check Out successfully!',
            errorMsg: 'Failed to check out!',
            additionalFunctions: [
                () => {
                    setShow(true)
                    setTimeout(() => {
                        setShow(false)
                        navigate(`/user-management`)
                    }, 2000)
                },
            ],
        })
    }

    const renderSubCategoryDetails = (subCat) => {
        return (
            <>
                <div className={addjob.addcontactdetails}>
                    {subCat.product?.length > 0 && (
                        subCat.product.map((product, productIndex) => (
                            <>
                                <div className={addjob.addjobinputs}>
                                    <label>Product Name</label>
                                    <input
                                        type="text"
                                        value={product.productId?.name || ''}
                                        readOnly
                                    />
                                </div>
                                <div className={addjob.addjobinputs}>
                                    <label>Quantity</label>
                                    <input
                                        type="text"
                                        value={product.quantity || 0}
                                        readOnly
                                    />
                                </div>
                                <div className={addjob.addjobinputs}>
                                    <label>Price Per Unit</label>
                                    <input
                                        type="text"
                                        value={`₹${product.productId?.price || 0}`}
                                        readOnly
                                    />
                                </div>
                                <div className={addjob.addjobinputs}>
                                    <label>Product Subtotal</label>
                                    <input
                                        type="text"
                                        value={`₹${product.total || product.quantity * product.productId?.price || 0}`}
                                        readOnly
                                    />
                                </div>
                            </>
                        ))
                    )}
                    <div className={addjob.addjobinputs}>
                        <label>Start Time</label>
                        <input
                            type="text"
                            value={formatCartJobTime(subCat.fromTime)}
                            readOnly
                        />
                    </div>
                    <div className={addjob.addjobinputs}>
                        <label>End Time</label>
                        <input
                            type="text"
                            value={formatCartJobTime(subCat.toTime)}
                            readOnly
                        />
                    </div>
                    <div className={addjob.addjobinputs}>
                        <label>Working Hours</label>
                        <input
                            type="text"
                            value={subCat.totalTime}
                            readOnly
                        />
                    </div>
                    {subCat.adults && (
                        <div className={addjob.addjobinputs}>
                            <label>Adults</label>
                            <input
                                type="text"
                                value={subCat.adults || 0}
                                readOnly
                            />
                        </div>
                    )}
                    {subCat.kids && (
                        <div className={addjob.addjobinputs}>
                            <label>Kids</label>
                            <input
                                type="text"
                                value={subCat.kids || 0}
                                readOnly
                            />
                        </div>
                    )}
                    {subCat.pax && (
                        <div className={addjob.addjobinputs}>
                            <label>Pax</label>
                            <input
                                type="text"
                                value={subCat.pax || 0}
                                readOnly
                            />
                        </div>
                    )}
                    <div className={addjob.addjobinputs}>
                        <label>Price Per Pax</label>
                        <input
                            type="text"
                            value={`₹${subCat.price || 0}`}
                            readOnly
                        />
                    </div>
                    <div className={addjob.addjobinputs}>
                        <label>Subtotal</label>
                        <input
                            type="text"
                            value={`₹${subCat.total || subCat.price * (subCat.adults + subCat.kids || subCat.pax || 0)}`}
                            readOnly
                        />
                    </div>

                </div>
                {/* Product Section */}
                {/* {subCat.product?.length > 0 && (
                    <div className={addjob.productSection}>
                        <div className={addjob.addjobtopic}>
                            <h6>Products</h6>
                        </div>
                        {subCat.product.map((product, productIndex) => (
                            <div key={product._id || productIndex} className={addjob.addcontactdetails}>
                                <div className={addjob.addjobinputs}>
                                    <label>Product Name</label>
                                    <input
                                        type="text"
                                        value={product.productId?.name || ''}
                                        readOnly
                                    />
                                </div>
                                <div className={addjob.addjobinputs}>
                                    <label>Quantity</label>
                                    <input
                                        type="text"
                                        value={product.quantity || 0}
                                        readOnly
                                    />
                                </div>
                                <div className={addjob.addjobinputs}>
                                    <label>Price Per Unit</label>
                                    <input
                                        type="text"
                                        value={`₹${product.productId?.price || 0}`}
                                        readOnly
                                    />
                                </div>
                                <div className={addjob.addjobinputs}>
                                    <label>Product Subtotal</label>
                                    <input
                                        type="text"
                                        value={`₹${product.total || product.quantity * product.productId?.price || 0}`}
                                        readOnly
                                    />
                                </div>
                            </div>
                        ))}
                    </div>
                )} */}
            </>
        )
    }
    const handleDeleteCart = async () => {
        const res = await deleteApi(endPoints.deletecart(id),{
            setLoading: setLoading2,
            successMsg: 'Cart Deleted successfully!',
            errorMsg: 'Failed to delete cart!',
            additionalFunctions: [
                () => {
                    setTimeout(() => {
                        navigate(`/user-management`);
                    }, 2000);
                },
            ],
        });
        navigate(`/user-management`);
        console.log('API Response:', res);
    };
    return (
        <>
            <SuccessfullyModal
                show={show}
                handleClose={() => setShow(false)}
                text={"Successfully CheckOut"}
            />
            <div className={addjob.jobmanagementCotainer}>
                <div className={addjob.jobtoppart}>
                    <div className={addjob.pagetitle}>
                        <h6>User Cart</h6>
                    </div>
                    <div className={addjob.rightbuttons}>
                        <div className={addjob.rightbuttons2} onClick={handleDeleteCart}>
                            <p>{loading2 ? "Deleting" : "Delete Cart"}</p>
                        </div>
                    </div>
                </div>

                <div className={addjob.addjobcontainer}>
                    <div className={addjob.addjobsubcontainer}>
                        <div className={addjob.addjobtopic}>
                            <h6>Order Details</h6>
                        </div>
                        {loading ? (
                            <div className={addjob.loadingnormal}>
                                <img src={img2} alt="Loading" width={100} height={100} />
                            </div>
                        ) : (
                            <>
                                <div className={addjob.addcontactdetails}>
                                    <div className={addjob.addjobinputs}>
                                        <label htmlFor="contactName">Contact Name</label>
                                        <input
                                            type="text"
                                            value={formData.contactName}
                                            readOnly
                                        />
                                    </div>
                                    <div className={addjob.addjobinputs}>
                                        <label htmlFor="name">Name</label>
                                        <input
                                            type="text"
                                            value={formData.name}
                                            readOnly
                                        />
                                    </div>
                                    <div className={addjob.addjobinputs}>
                                        <label htmlFor="phone">Contact Phone</label>
                                        <input
                                            type="text"
                                            value={formData.phone}
                                            readOnly
                                        />
                                    </div>
                                    <div className={addjob.addjobinputs}>
                                        <label htmlFor="address">Address</label>
                                        <input
                                            type="text"
                                            value={formData.address}
                                            readOnly
                                        />
                                    </div>
                                    <div className={addjob.addjobinputs}>
                                        <label htmlFor="parkingAccess">Parking Access</label>
                                        <input
                                            type="text"
                                            value={formData.parkingAccess}
                                            readOnly
                                        />
                                    </div>
                                    <div className={addjob.addjobinputs}>
                                        <label htmlFor="outfits">Outfits</label>
                                        <input
                                            type="text"
                                            value={formData.outfits.join(', ')}
                                            readOnly
                                        />
                                    </div>
                                    <div className={addjob.addjobinputs}>
                                        <label htmlFor="equipment">Equipment</label>
                                        <input
                                            type="text"
                                            value={formData.equipment.join(', ')}
                                            readOnly
                                        />
                                    </div>
                                    <div className={addjob.addjobinputs}>
                                        <label htmlFor="mobility">Mobility</label>
                                        <input
                                            type="text"
                                            value={formData.mobility.join(', ')}
                                            readOnly
                                        />
                                    </div>
                                </div>

                                <div className={addjob.addjobinputs}>
                                    <label htmlFor="description">Order Description</label>
                                    <textarea
                                        value={formData.description}
                                        readOnly
                                    />
                                </div>

                                <div className={addjob.addjobtopic}>
                                    <h6>Job Details</h6>
                                </div>

                                {formData.jobs.map((job, jobIndex) => (
                                    <div key={job._id || jobIndex} className={addjob.jobSection}>
                                        <div className={addjob.addjobtopic}>
                                            <h6>Job {jobIndex + 1}</h6>
                                        </div>
                                        <div className={addjob.addcontactdetails}>
                                            <div className={addjob.addjobinputs}>
                                                <label>Category</label>
                                                <input
                                                    type="text"
                                                    value={job.category?.name || ''}
                                                    readOnly
                                                />
                                            </div>
                                            <div className={addjob.addjobinputs}>
                                                <label>Date</label>
                                                <input
                                                    type="text"
                                                    value={formatDate(job.date)}
                                                    readOnly
                                                />
                                            </div>
                                        </div>

                                        {/* {job.subCategories?.map((subCat, subIndex) => (
                                            <div key={subCat._id || subIndex} className={addjob.subCategorySection}>
                                                <div className={addjob.addjobtopic}>
                                                    <h6>Subcategory {subIndex + 1}</h6>
                                                </div>
                                                <div className={addjob.addcontactdetails}>
                                                    <div className={addjob.addjobinputs}>
                                                        <label>Subcategory</label>
                                                        <input
                                                            type="text"
                                                            value={subCat.subCategoryId?.name || ''}
                                                            readOnly
                                                        />
                                                    </div>

                                                </div>
                                                {renderSubCategoryDetails(subCat)}
                                            </div>
                                        ))} */}
                                        {job.subCategories?.some(sub => sub.product?.length > 0) ? (
                                            job.subCategories?.map((subCat, subIndex) => (
                                                <div key={subCat._id || subIndex} className={addjob.subCategorySection}>
                                                    <div className={addjob.addjobtopic}>
                                                        <h6>Product {subIndex + 1}</h6>
                                                    </div>
                                                    <div className={addjob.addcontactdetails}>
                                                        {/* <div className={addjob.addjobinputs}>
                                                        <label>Subcategory</label>
                                                        <input
                                                            type="text"
                                                            value={subCat.subCategoryId?.name || ''}
                                                            readOnly
                                                        />
                                                    </div> */}

                                                    </div>
                                                    {renderSubCategoryDetails(subCat)}
                                                </div>
                                            ))
                                        ) : (
                                            job.subCategories?.map((subCat, subIndex) => (
                                                <div key={subCat._id || subIndex} className={addjob.subCategorySection}>
                                                    <div className={addjob.addjobtopic}>
                                                        <h6>Subcategory {subIndex + 1}</h6>
                                                    </div>
                                                    <div className={addjob.addcontactdetails}>
                                                        <div className={addjob.addjobinputs}>
                                                            <label>Subcategory</label>
                                                            <input
                                                                type="text"
                                                                value={subCat.subCategoryId?.name || ''}
                                                                readOnly
                                                            />
                                                        </div>

                                                    </div>
                                                    {renderSubCategoryDetails(subCat)}
                                                </div>
                                            ))
                                        )}
                                    </div>
                                ))}

                                <div className={addjob.addjobtopic}>
                                    <h6>Invoice Details</h6>
                                </div>
                                <div className={addjob.addcontactdetails}>
                                    <div className={addjob.addjobinputs}>
                                        <label>Invoice Name</label>
                                        <input
                                            type="text"
                                            value={formData.invoiceName}
                                            readOnly
                                        />
                                    </div>
                                    <div className={addjob.addjobinputs}>
                                        <label>Invoice Address</label>
                                        <input
                                            type="text"
                                            value={formData.invoiceAddress}
                                            readOnly
                                        />
                                    </div>
                                    <div className={addjob.addjobinputs}>
                                        <label>Invoice Country</label>
                                        <input
                                            type="text"
                                            value={formData.invoiceCountry}
                                            readOnly
                                        />
                                    </div>
                                    <div className={addjob.addjobinputs}>
                                        <label>Invoice City</label>
                                        <input
                                            type="text"
                                            value={formData.invoiceCity}
                                            readOnly
                                        />
                                    </div>
                                    <div className={addjob.addjobinputs}>
                                        <label>Invoice PinCode</label>
                                        <input
                                            type="text"
                                            value={formData.invoicePinCode}
                                            readOnly
                                        />
                                    </div>
                                    <div className={addjob.addjobinputs}>
                                        <label>Company Registration</label>
                                        <input
                                            type="text"
                                            value={formData.companyRegistrationNumber}
                                            readOnly
                                        />
                                    </div>
                                    <div className={addjob.addjobinputs}>
                                        <label>Invoice Details</label>
                                        <textarea
                                            value={formData.invoiceDetails}
                                            readOnly
                                        />
                                    </div>
                                </div>

                                <div className={addjob.addjobtopic}>
                                    <h6>Order Summary</h6>
                                </div>
                                <div className={addjob.addcontactdetails}>
                                    <div className={addjob.addjobinputs}>
                                        <label>Subtotal</label>
                                        <input
                                            type="text"
                                            value={`₹${formData.subTotal}`}
                                            readOnly
                                        />
                                    </div>
                                    <div className={addjob.addjobinputs}>
                                        <label>GST (18%)</label>
                                        <input
                                            type="text"
                                            value={`₹${formData.vat}`}
                                            readOnly
                                        />
                                    </div>
                                    <div className={addjob.addjobinputs}>
                                        <label>Total</label>
                                        <input
                                            type="text"
                                            value={`₹${formData.total}`}
                                            readOnly
                                        />
                                    </div>
                                </div>
                            </>
                        )}
                    </div>

                    <div className={addjob.addjobbutton}>
                        <div className={addjob.rightbuttons}>
                            <button onClick={() => navigate('/user-management')}>Back</button>
                        </div>
                        <div className={addjob.rightbuttons}>
                            <button
                                onClick={handleSubmit}
                                style={{ background: '#F05423' }}
                                disabled={loading1}
                            >
                                {loading1 ? "Checkouting..." : "CheckOut"}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default HOC(UserCart)